import { Box } from "@mui/material";
import React, { useMemo, useState } from "react";

import AccountCircle from "@mui/icons-material/AccountCircle";
import AdminPanelSettingsOutlinedIcon from "@mui/icons-material/AdminPanelSettingsOutlined";
import AppBar from "@mui/material/AppBar";
import BadgeOutlinedIcon from "@mui/icons-material/BadgeOutlined";
import HeaderContent from "./HeaderContent";
import HeaderMenu from "./HeaderMenu";
import IconButton from "@mui/material/IconButton";
import { Link } from "react-router-dom";
import LogoutIcon from "@mui/icons-material/Logout";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import MoreIcon from "@mui/icons-material/MoreVert";
import PersonIcon from "@mui/icons-material/Person";
import ProfilePhoto from "../ProfilePhoto";
import Toolbar from "@mui/material/Toolbar";
import nativeCodersLogo from "../../images/HeaderFrame.png"
import { useAuth } from "../../providers/AuthProvider";
import { useProfile } from "../../providers/ProfileProvider";

const adminMenuItems = (onLogout) => [
  { text: "Profile", icon: PersonIcon, path: "/profile" },
  { text: "My Account", icon: BadgeOutlinedIcon, path: "/account" },
  { text: "Sign out", icon: LogoutIcon, onClick: onLogout },
];

const candidateMenuItems = (onLogout) => [
  { text: "Profile", icon: PersonIcon, path: "/profile" },
  { text: "Account & Security", icon: BadgeOutlinedIcon, path: "/account" },
  { text: "Engagement & Admin", icon: AdminPanelSettingsOutlinedIcon, path: "/admin" },
  { text: "Sign out", icon: LogoutIcon, onClick: onLogout },
];

const Header = () => {
  const [anchorEl, setAnchorEl] = useState(null);
  const [mobileMoreAnchorEl, setMobileMoreAnchorEl] = useState(null);
  const auth = useAuth();
  const profile = useProfile();

  const isAdmin = auth?.hasRealmRole?.("admin") ?? false;
  const menuItems = useMemo(
    () => (isAdmin ? adminMenuItems(auth.logout) : candidateMenuItems(auth.logout)),
    [isAdmin, auth.logout]
  );

  const isMenuOpen = Boolean(anchorEl);
  const isMobileMenuOpen = Boolean(mobileMoreAnchorEl);

  const handleProfileMenuOpen = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleMobileMenuClose = () => {
    setMobileMoreAnchorEl(null);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
    handleMobileMenuClose();
  };

  const handleMobileMenuOpen = (event) => {
    setMobileMoreAnchorEl(event.currentTarget);
  };

  const menuId = "primary-search-account-menu";
  const userName = profile ? `${profile.firstName} ${profile.lastName}`.trim() : "";
  const userEmail = profile?.email ?? "";

  const mobileMenuId = "primary-search-account-menu-mobile";
  const renderMobileMenu = (
    <Menu
      anchorEl={mobileMoreAnchorEl}
      anchorOrigin={{ vertical: "top", horizontal: "right" }}
      id={mobileMenuId}
      keepMounted
      transformOrigin={{ vertical: "top", horizontal: "right" }}
      open={isMobileMenuOpen}
      onClose={handleMobileMenuClose}
    >
      <MenuItem onClick={handleProfileMenuOpen}>
        <IconButton
          aria-label="account of current user"
          aria-controls="primary-search-account-menu"
          aria-haspopup="true"
          color="inherit"
        >
          <AccountCircle />
        </IconButton>
        <p>Profile</p>
      </MenuItem>
    </Menu>
  );


  return (
    <Box sx={{ flexGrow: 1 }}>
      <AppBar position="static" sx={{ backgroundColor: "#463C3B" }}>
        <Toolbar>
          {/* Logo on the left */}
          <Box sx={{ mr: 2, pl: 3 }}>
            <Link to="/" style={{ textDecoration: 'none' }}>
              <img 
                src={nativeCodersLogo} 
                alt="Native Coders Logo" 
                style={{ 
                  height: '40px', 
                  width: 'auto',
                  display: 'block',
                  cursor: 'pointer'
                }} 
              />
            </Link>
          </Box>

          <Box sx={{ 
            display: 'flex', 
            justifyContent: 'center', 
            alignItems: 'center',
            flexGrow: 1 
          }}>
            <HeaderContent />
          </Box>


          <Box sx={{ display: { xs: "none", md: "flex" } }}>
            <IconButton
              edge="end"
              aria-label="account of current user"
              aria-controls={menuId}
              aria-haspopup="true"
              onClick={handleProfileMenuOpen}
              color="inherit"
              disableRipple
              disableFocusRipple
              sx={{ mb: 0 }}
            >
              <ProfilePhoto
                firstName={profile?.firstName ?? "O"}
                lastName={profile?.lastName ?? "P"}
              />
            </IconButton>
          </Box>
          <Box sx={{ display: { xs: "flex", md: "none" } }}>
            <IconButton
              aria-label="show more"
              aria-controls={mobileMenuId}
              aria-haspopup="true"
              onClick={handleMobileMenuOpen}
              color="inherit"
            >
              <MoreIcon />
            </IconButton>
          </Box>
        </Toolbar>
      </AppBar>
      {renderMobileMenu}
      <HeaderMenu
        anchorEl={anchorEl}
        open={isMenuOpen}
        onClose={handleMenuClose}
        items={menuItems}
        userName={userName}
        userEmail={userEmail}
      />
    </Box>
  );
};

export default Header;